const SET_THEME = "SET_THEME";

function setCurrentTheme(theme) {
  return {
    type: SET_THEME,
    payload: theme,
  };
}

export { SET_THEME, setCurrentTheme };
